module.exports = __webpack_public_path__ + "img/login-hero.977611e8.png";